/**
 * 테마 — 다크 기본(§14).
 *
 * 자막 크기(발표 모드)는 여기 있었지만 **+/− 단계 스테퍼로 대체**됐다:
 * lib/caption-scale.ts(값) + lib/use-caption-scale.ts(적용). 프리셋 셋으로는
 * 회의실마다 다른 요구를 맞출 수 없었고, 프리셋마다 원문/번역 비율이
 * 제각각이라 키울수록 위계가 흐트러졌다.
 */

import { useCallback, useEffect, useState } from 'react'

/** 다크 기본(§14) — 사용자가 토글하면 유지한다. */
export function useTheme(): { dark: boolean; toggle: () => void } {
  const [dark, setDark] = useState<boolean>(() => {
    if (typeof localStorage === 'undefined') return true
    return localStorage.getItem('omnitrans:theme') !== 'light'
  })

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', dark ? 'dark' : 'light')
    try {
      localStorage.setItem('omnitrans:theme', dark ? 'dark' : 'light')
    } catch {
      /* 무시 */
    }
  }, [dark])

  return { dark, toggle: useCallback(() => setDark((d) => !d), []) }
}
